import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder" }, "Personal"),
  /*#__PURE__*/_createElementVNode("p", { class: "lead fw-normal text-muted mb-0" }, "Lista de Personal Médico del Hospital")
], -1)
const _hoisted_2 = { class: "row gx-5 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Doctores = _resolveComponent("Doctores")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Doctores)
    ])
  ], 64))
}